import React, { FC } from 'react';
import { create } from 'zustand';

export interface MessageStore {
  activeItems: Array<{ id: string; status: string }>;
  status: '' | 'correct' | 'wrong';
  setStatus(id: string, answer: boolean): void;
  firstElement: string | null;
  setFirstElement(id: string): void;
  feedback: string;
  narration?: string;
  subtitlesUrl?: string;
  playAudio: boolean;
  setFeedback: (feedback?: string) => void;
  setNarration: (narration?: string) => void;
  setSubtitlesUrl: (subtitlesUrl?: string) => void;
  setPlayAudio: (play?: boolean) => void;
}

const _useMessageStore = create<MessageStore>((set, get) => ({
  firstElement: null,
  activeItems: [],
  status: '',
  feedback: '',
  narration: '',
  subtitlesUrl: '',
  playAudio: false,
  setNarration: narration => set({ narration }),
  setSubtitlesUrl: subtitlesUrl => set({ subtitlesUrl }),
  setPlayAudio: (play: boolean) => set({ playAudio: play }),
  setFeedback: feedback => set({ feedback: feedback || '' }),
  setFirstElement: id => set({ firstElement: id }),
  setStatus: (id, answer) => {
    let activeItems = get().activeItems;
    const item = { id, status: answer ? 'correct' : 'wrong' };
    const selectedOption = activeItems.find(el => el.id == id);

    if (selectedOption) {
      activeItems = activeItems.filter(el => el.id != id);
    } else {
      activeItems.push(item);
    }
    set({ activeItems, status: answer ? 'correct' : 'wrong' });
  }
}));

export const MessageProvider: FC = ({ children }) => <>{children}</>;

export const useMessageStore = _useMessageStore;
